if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    observerConfig = {
      rootMargin: '100% 0px 100% 0px',
    };

    selectors = {
      recommendations: 'cart-recommendations',
      container: '[data-container]',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.observer = new IntersectionObserver(
        this.handleObserver.bind(this),
        this.observerConfig,
      );

      this.observer.observe(this);
    }

    fetchRec(intent) {
      if (!intent) return;
      const { url } = this.dataset;

      this.setAttribute('is-loading', true);

      fetch(`${url}&intent=${intent}`)
        .then((res) => res.text())
        .then((res) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(res, 'text/html');

          const staleContainer = this.querySelector(this.selectors.container);
          const newContainer = doc.querySelector(this.selectors.container);

          if (newContainer && newContainer.innerHTML.trim().length) {
            staleContainer.innerHTML = newContainer.innerHTML;
            this.removeAttribute('is-loading');
          } else if (intent === 'complementary') {
            this.fetchRec('related');
          }
        })
        .catch((err) => {
          console.error({ err });
          this.removeAttribute('is-loading');
        });
    }

    handleObserver(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.fetchRec('complementary');
          observer.unobserve(entry.target);
        }
      });
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
}
